import styled from "styled-components";

export const TagDashboard = styled.span`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border: none;
  border-radius: 10px;
  padding: 2px 6px;
  margin-left: 4px;
  text-transform: uppercase;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
`;

export const NavMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  
  i {
    font-size: 16px;
    margin-bottom: 4px;
  }
  
  span {
    font-size: 12px;
    font-weight: 500;
  }
`;

export const NavMenuLink = styled.a`
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  padding: 8px 12px !important;
  min-width: 80px;
  
  &.nav-link {
    i {
      font-size: 18px !important;
      margin-bottom: 4px !important;
      margin-right: 0 !important;
    }
  }
`;
